import { preOrder } from '@/api/peripheral';
import { fetchCheckInClients } from '@/api/goods';

export interface IPreOrderDetailItem {
  goodsPrice?: number;
  saleCount: number;
  saleTimeCount: number;
  skuCode: string;
}

interface IPreOrderDetailRest {
  // resvNo: string;
  roomId: any;
  roomNo: string;
}

interface IHomeOwner {
  certNo: string;
  name: string;
  roomNo: string;
  resvNo: string;
}

// 续租
export const getRenewalParams = async ({
  details,
  leaseType,
  rest,
}: {
  details: IPreOrderDetailItem[];
  leaseType: 1 | 2;
  rest: IPreOrderDetailRest;
}) => {
  try {
    let recNo = '';
    let resvNo = '';
    let owner: any = {};

    const result: any = await fetchCheckInClients();

    if (result.code === 0) {
      const roomList = result?.data || [];
      const homeowner = (roomList || []).find((item) => item.roomId === rest.roomId)?.homeowner;
      const { certNo, name } = homeowner || {};
      owner = { ...owner, ...homeowner, certNo, name, roomNo: rest.roomNo };
      recNo = homeowner?.recNo || '';
      resvNo = homeowner?.resvNo || '';
    }

    const res: any = await preOrder({
      details,
      leaseType, // 1-正常新租  2-续租
      saleType: 0,
      ...rest,
      recNo,
      resvNo,
    });

    return { orderNo: res?.data, homeowner: owner };
  } catch (error) {
    return { orderNo: '', homeowner: {} };
  }
};
